import { forwardRef, ForwardRefRenderFunction } from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { BaseFormComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { SalaryFormTypes } from "models/formTypes";
import { AutocompleteListItem } from "models/propTypes/listPropTypes";
//#endregion
//#region components
import AddExtraSalaryForm from "./addExtraSalaryForm";
import { useSalaryService } from "serviceHooks";
//#endregion
import * as Yup from "yup";
import useSalaryEmployeeSearch from "./useSalaryEmployeeSearch";

const AddExtraSalaryFormContainer: ForwardRefRenderFunction<FormHandles, BaseFormComponentProps> = (props, ref) => {
  const salaryService = useSalaryService();
  const loggedInUser = useSelector((store: AppState) => store.auth.loggedInUser);

  const { employeeSuggestions, searchEmployees } = useSalaryEmployeeSearch();

  const initialValues = {
    employee: { id: loggedInUser.personId, value: loggedInUser.name },
  } as SalaryFormTypes.AddExtraSalary;

  const validationSchema = Yup.object<SalaryFormTypes.AddExtraSalary>({
    employee: Yup.object<AutocompleteListItem>().required(TranslationKeys.Validations.Required),
    amount: Yup.number().required(TranslationKeys.Validations.Required),
  });

  const handleFormSubmit = (values: SalaryFormTypes.AddExtraSalary) => {
    const salary: WintSuperkollAPIModel.PersonSalaryExtraEntryPost = {
      employeeId: values.employee.id as number,
      grossAmount: values.amount,
      isHandledByWint: true,
    };

    return salaryService.addExtraSalary(salary);
  };

  return (
    <AddExtraSalaryForm
      ref={ref}
      defaultValues={initialValues}
      handleSubmit={handleFormSubmit}
      validationSchema={validationSchema}
      employeeSuggestions={employeeSuggestions}
      searchEmployees={searchEmployees}
    />
  );
};

export default forwardRef(AddExtraSalaryFormContainer);
